import PropTypes from 'prop-types';

import type { IconType } from '../../theme/themes/ThemeTypes';

const Overview: IconType = ({ colour, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="35"
    height="39"
    viewBox="0 0 35 39"
    {...props}
  >
    <defs>
      <path
        id="account_overview-a"
        d="M177.008 1068.12a17.428 17.428 0 013.992 11.126c0 9.665-7.835 17.5-17.5 17.5s-17.5-7.835-17.5-17.5c0-4.226 1.498-8.102 3.992-11.126a2.871 2.871 0 00.566 2.703 15.363 15.363 0 00-2.5 8.423c0 4.264 1.73 8.124 4.523 10.919 2.795 2.794 6.655-.625 10.919-.625s8.124 3.419 10.919.625a15.393 15.393 0 004.522-10.919c0-3.108-.918-6.002-2.499-8.425a2.876 2.876 0 00.597-2.597zm-14.206-9.847a1.03 1.03 0 011.396 0l10.75 9.923a1.03 1.03 0 01-.699 1.785h-1.484v12.353a2.059 2.059 0 01-2.06 2.06h-4.117v-7.207c0-.568-.46-1.03-1.03-1.03h-4.117c-.568 0-1.03.462-1.03 1.03v7.206h-4.117a2.059 2.059 0 01-2.059-2.059v-12.353h-1.484a1.03 1.03 0 01-.699-1.785z"
      ></path>
    </defs>
    <use fill={colour} transform="translate(-146 -1058)" xlinkHref="#account_overview-a"></use>
  </svg>
);

Overview.propTypes = {
  colour: PropTypes.string.isRequired,
};

export default Overview;
